var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none",
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    fillRule: "evenodd",
    d: "M10.693 14.876c-.454-.454-1.19-.454-1.643 0l-2.372 2.371V9.538c0-.641-.52-1.162-1.161-1.162-.642 0-1.162.52-1.162 1.162v7.71l-2.372-2.372c-.454-.454-1.19-.454-1.643 0-.454.454-.454 1.19 0 1.643l4.192 4.192c.268.268.635.378.984.328.35.05.717-.06.985-.329l4.192-4.191c.454-.454.454-1.19 0-1.643zm4.952-2.69c0 .641-.52 1.161-1.162 1.161-.641 0-1.161-.52-1.161-1.162V4.476L10.95 6.848c-.454.454-1.19.454-1.643 0-.454-.454-.454-1.19 0-1.643l4.192-4.192c.268-.268.635-.378.984-.329.35-.049.717.06.985.33l4.192 4.19c.453.455.453 1.19 0 1.644-.454.454-1.19.454-1.643 0l-2.372-2.372v7.71z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.58a06393.svg";
export { ForwardRef as ReactComponent };